enum InternalNames {
    Item = "Item Number",
    Order = "Order Number",
}

export const BriefcaseCaseTagNames = {
    InternalNames,
};
